/* eslint-disable import/prefer-default-export */
export const selectMenuOpened = store => store.menu.menuOpened;
